// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegisterVehiclePropertyChangeDisplayType {
  Unknown = "UNKNOWN",
  LicensePlateChange = "LICENSE_PLATE_CHANGE",
  LicensePlateValidSinceDateChange = "LICENSE_PLATE_VALID_SINCE_DATE_CHANGE",
  LicensePlateValidUntilDateChange = "LICENSE_PLATE_VALID_UNTIL_DATE_CHANGE",
  FuelTypesChange = "FUEL_TYPES_CHANGE",
  FuelTypeName1Change = "FUEL_TYPE_NAME1_CHANGE",
  FuelTypeName2Change = "FUEL_TYPE_NAME2_CHANGE",
  FuelTypeName3Change = "FUEL_TYPE_NAME3_CHANGE",
  ClassifiedFuelTypeChange = "CLASSIFIED_FUEL_TYPE_CHANGE",
  EmissionsCo2Change = "EMISSIONS_CO2_CHANGE",
  CategoryChange = "CATEGORY_CHANGE",
  CategoryNameChange = "CATEGORY_NAME_CHANGE",
  MaximumAllowedWeightChange = "MAXIMUM_ALLOWED_WEIGHT_CHANGE",
  VehicleStatusChange = "VEHICLE_STATUS_CHANGE",
  VehicleStatusValidSinceDateChange = "VEHICLE_STATUS_VALID_SINCE_DATE_CHANGE",
  VehicleStatusValidUntilDateChange = "VEHICLE_STATUS_VALID_UNTIL_DATE_CHANGE",
  VinChange = "VIN_CHANGE",
}
export default VehicleRegisterVehiclePropertyChangeDisplayType;
